<template>
  <v-layout row wrap>
    <v-flex v-for="(system, index) in systems" :key="index" xs3 class="mb-2">
      <v-card>
        <v-card-title primary>{{ system.title }}</v-card-title>
        <v-divider />
        <v-card-text>
          <div>
            <pie-chart
              :chart-data="system"
              :options="options"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import PieChart from '@/components/PieChart'
import FileSystem from '@/models/FileSystem'

export default {
  data () {
    let self = this
    return {
      systems: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              let sum = data.datasets[0].data.reduce((a, b) => a + b, 0)
              return Math.round((data.datasets[0].data[tooltipItems.index] / sum) * 10000) / 100 + ' %'
            },
            title: function (tooltipItems, data) {
              return data.labels[tooltipItems[0].index] + ': ' + self.$format.fileSize(data.datasets[0].data[tooltipItems[0].index])
            }
          },
          titleFontColor: '#fff',
          bodyFontColor: '#fff',
          footerFontColor: '#fff'
        }
      }
    }
  },
  created () {
    FileSystem
      .getList()
      .then(systems => {
        this.systems = systems.map(item => {
          return {
            title: item.name,
            datasets: [
              {
                backgroundColor: [
                  '#E46651',
                  '#41B883'
                ],
                data: [item.totalSpace - item.usableSpace, item.usableSpace]
              }
            ],
            labels: [ this.$t('space.used'), this.$t('space.free') ]
          }
        })
      })
  },
  components: {
    PieChart
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SystemStorageReport.vue?23d0e0bc